import axios from 'axios'
import {
    PersonnelAutomaticAssignmentConfigurationPatchRequest,
    PersonnelAutomaticAssignmentConfigurationResponse
} from '@/modules/configurationModule/detail/automation/personnel/algorithms-selection/services/configuration-personnel-automatic-assignment-configuration/configuration-personnel-automatic-assignment-configuration.dto'

class ConfigurationPersonnelAutomaticAssignmentConfigurationService {
    async get(laboratoryId: number): Promise<PersonnelAutomaticAssignmentConfigurationResponse> {
        const response = await axios.get<PersonnelAutomaticAssignmentConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/personnelAutomaticAssignmentConfiguration`)
        return response.data
    }

    async patch(laboratoryId: number, request: PersonnelAutomaticAssignmentConfigurationPatchRequest): Promise<void> {
        const response = await axios.patch<void>(`/configuration/laboratories/${laboratoryId}/personnelAutomaticAssignmentConfiguration`, request)
        return response.data
    }
}

export const configurationPersonnelAutomaticAssignmentConfigurationService = new ConfigurationPersonnelAutomaticAssignmentConfigurationService()
